<template>
    <div class="messageNotification"
        :class="{error: type === 'error', info: type === 'info', progress: type === 'progress'}" >
        <div class="content">
            <div class="title">
                <span class="icon"></span>
                <strong v-if="title">{{title}}</strong>
            </div>
            {{body}}
            <PulseLoader v-if="type === 'progress' " size="8px" color="#fff"/>
            <span class="close" @click="removeMessage(i)"></span>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        props: {
            body: {
                type: String
            },
            title: {
                type: String
            },
            type: {
                type: String
            },
            i: {
                type: Number
            }
        },

        components: { PulseLoader },

        mounted() {
            if (this.$mq==='sm') {
                setTimeout(() => {
                    this.removeMessage(this.$vnode.key);
                }, 5000);
            }

        },

        methods: {
            ...mapActions(['removeMessage']),
        },
        watch: {

        }
    }
</script>
